import React from 'react';
import {
  Alert,
} from 'antd';
import PropTypes from 'prop-types';

const CollectionStatusAlert = (props) => {
  const {
    collectionStatus,
  } = props;

  return (
    <Alert
      showIcon
      message={`Viewing observation data with collection_status=${collectionStatus}`}
      type="warning"
      style={{
        marginTop: 10,
        marginBottom: 10,
      }}
    />
  );
};

CollectionStatusAlert.propTypes = {
  collectionStatus: PropTypes.string,
};

CollectionStatusAlert.defaultProps = {
  collectionStatus: '',
};

export default CollectionStatusAlert;
